import React, { useState, useContext } from 'react';
import Accordion from '../../../../../../components/Accordion/Accordion';
import TextField from '@material-ui/core/TextField';
import {
  toEN,
  checkMobilePhone,
  normalizeMobilePhone,
} from '../../../../../../fns';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { store as mainStore } from '../../../../../../store';
import axios from '../../../../../../api/axios';
import SendSMSDialog from 'views/Protected/Admin/Orders/Order/Drivers/SendSMSDialog';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& >*:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const InformUser = () => {
  const classes = useStyles();
  const initialState = {
    mobilePhone: '',
    url: 'https://footab.ir/downloads',
    toggleButton: 'downloads',
  };
  const [values, setValues] = useState(initialState);
  const { mobilePhone, url, toggleButton } = values;
  const { showMessage, showError } = useContext(mainStore);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    name === 'mobilePhone' && (value = checkMobilePhone(value) || value);
    setValues({ ...values, [name]: value });
  };
  const handleChangeToggle = (event, newValue) => {
    const links = {
      pwa: 'https://elb.footab.ir',
      direct: 'https://footab.ir/download/footab.apk',
      baazar: 'https://cafebazaar.ir/app/ir.footab',
      downloads: 'https://footab.ir/downloads',
    };
    setValues({ ...values, toggleButton: newValue, url: links[newValue] });
  };
  const handleSendSMS = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(`/api/v1/admin/users/sendAppLink`, {
        mobilePhone,
        url,
      });
      if (data?.ok) {
        showMessage(data.messages);
        setValues(initialState);
      }
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Accordion title="اطلاع رسانی پیامکی به کاربر">
      <div className={classes.root}>
        <TextField
          variant="outlined"
          label="شماره موبایل"
          fullWidth
          size="small"
          name="mobilePhone"
          onChange={handleChange}
          value={normalizeMobilePhone(mobilePhone)}
        />
        <ToggleButtonGroup
          exclusive
          value={toggleButton}
          onChange={handleChangeToggle}
        >
          <ToggleButton value="pwa">نسخه PWA</ToggleButton>
          <ToggleButton disabled value="direct">لینک مستقیم اندروید</ToggleButton>
          <ToggleButton disabled value="downloads">صفحه دانلود</ToggleButton>
          <ToggleButton disabled value="baazar">لینک کافه بازار</ToggleButton>
        </ToggleButtonGroup>
        <TextField
          variant="outlined"
          label="URL ارسالی"
          value={url}
          fullWidth
          name="url"
          onChange={handleChange}
          size="small"
        />
        <Button
          variant="contained"
          color="secondary"
          size="small"
          endIcon={
            loading ? <CircularProgress size={10} /> : <MailOutlineIcon />
          }
          disabled={!checkMobilePhone(mobilePhone) || loading}
          onClick={handleSendSMS}
        >
          ارسال پیامک
        </Button>
      </div>
    </Accordion>
  );
};

export default React.memo(InformUser);
